// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { ClientProfileFragment, ClientProfileMinimalGrantorRelationshipFragment, RelationshipFragment, ClientProfileBasicFragment } from '../../../clientProfiles/graphql/ClientProfile.generated';
import { SubBrandFragment } from '../../../admin/branding/graphql/Branding.generated';
import { gql } from '@apollo/client';
import { ClientProfileFragmentDoc, ClientProfileMinimalGrantorRelationshipFragmentDoc, RelationshipFragmentDoc, ClientProfileBasicFragmentDoc } from '../../../clientProfiles/graphql/ClientProfile.generated';
import { SubBrandFragmentDoc } from '../../../admin/branding/graphql/Branding.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ClientFormDataQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.HouseholdWhereInput>;
}>;


export type ClientFormDataQuery = { __typename?: 'Query', households: { __typename?: 'HouseholdConnection', edges?: Array<{ __typename?: 'HouseholdEdge', node?: { __typename?: 'Household', id: string, billableKind: Types.HouseholdBillableKind, primaryRelationshipOwner: { __typename?: 'User', id: string, displayName: string }, clientProfiles?: Array<(
          { __typename?: 'ClientProfile', relationships?: Array<(
            { __typename?: 'ClientProfileRelationship' }
            & RelationshipFragment
          )> | null }
          & ClientProfileFragment
        )> | null, possiblePrimaryClients: Array<(
          { __typename?: 'ClientProfile' }
          & ClientProfileBasicFragment
        )>, subBrand?: { __typename?: 'SubBrand', id: string } | null, assignedTeams?: Array<{ __typename?: 'Team', id: string }> | null } | null } | null> | null }, subBrands: { __typename?: 'SubBrandConnection', edges?: Array<{ __typename?: 'SubBrandEdge', node?: (
        { __typename?: 'SubBrand' }
        & SubBrandFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    ClientFormData: 'ClientFormData' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const ClientFormDataDocument = gql`
    query ClientFormData($where: HouseholdWhereInput) {
  households(where: $where) {
    edges {
      node {
        id
        billableKind
        primaryRelationshipOwner {
          id
          displayName
        }
        clientProfiles {
          ...ClientProfile
          relationships {
            ...Relationship
          }
        }
        possiblePrimaryClients {
          ...ClientProfileBasic
        }
        subBrand {
          id
        }
        assignedTeams {
          id
        }
      }
    }
  }
  subBrands {
    edges {
      node {
        ...SubBrand
      }
    }
  }
}
    ${ClientProfileFragmentDoc}
${RelationshipFragmentDoc}
${ClientProfileBasicFragmentDoc}
${SubBrandFragmentDoc}`;

/**
 * __useClientFormDataQuery__
 *
 * To run a query within a React component, call `useClientFormDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientFormDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientFormDataQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useClientFormDataQuery(baseOptions?: Apollo.QueryHookOptions<ClientFormDataQuery, ClientFormDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientFormDataQuery, ClientFormDataQueryVariables>(ClientFormDataDocument, withFetchPolicyContext(options));
      }
export function useClientFormDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientFormDataQuery, ClientFormDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientFormDataQuery, ClientFormDataQueryVariables>(ClientFormDataDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useClientFormDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ClientFormDataQuery, ClientFormDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClientFormDataQuery, ClientFormDataQueryVariables>(ClientFormDataDocument, withFetchPolicyContext(options));
        }
export type ClientFormDataQueryHookResult = ReturnType<typeof useClientFormDataQuery>;
export type ClientFormDataLazyQueryHookResult = ReturnType<typeof useClientFormDataLazyQuery>;
export type ClientFormDataSuspenseQueryHookResult = ReturnType<typeof useClientFormDataSuspenseQuery>;
export type ClientFormDataQueryResult = Apollo.QueryResult<ClientFormDataQuery, ClientFormDataQueryVariables>;